import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function AppStateScreen({
  icon: Icon,
  title,
  body,
  tone = "neutral",
  children,
  className = "",
}: {
  icon: LucideIcon;
  title: string;
  body?: ReactNode;
  tone?: "neutral" | "success" | "waiting" | "sad";
  children?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`app-state-screen app-state-screen--${tone} ${className}`.trim()}>
      <div className="app-state-screen-icon" aria-hidden="true">
        <Icon size={34} />
      </div>
      <div className="app-state-screen-copy">
        <h2>{title}</h2>
        {body && (
          <div className="app-state-screen-body">
            {typeof body === "string" ? <p>{body}</p> : body}
          </div>
        )}
      </div>
      {children && <div className="app-state-screen-actions">{children}</div>}
    </section>
  );
}
